module.exports = __webpack_public_path__ + "static/media/29FUNOV5.24641925.jpg";